/**
 * Product Quantity Limits Handler
 * Enforces per-product quantity limits based on Product Type / Tags:
 * - Oral Drops = 3
 * - Mango Gummies = 10
 * - Other Gummies = 6
 */

(function () {
  'use strict';

  function isMangoGummiesItem(context) {
    let text = '';
    if (typeof context === 'object' && context !== null) {
      text = [
        context.title || '',
        context.product_title || '',
        context.handle || '',
        context.product_type || '',
        context.variant_title || '',
        context.url || '',
        Array.isArray(context.tags) ? context.tags.join(' ') : (context.tags || ''),
        Array.isArray(context.options_with_values) ? context.options_with_values.map(o => o.value).join(' ') : ''
      ].join(' ').toLowerCase();
    } else {
      text = String(context || '').toLowerCase();
    }

    if (
      text.includes('uplift-gummiesvati-thc-dominant-instant-uplift') ||
      text.includes('uplift-gummies-full-spectrum-terpenes-500mg') ||
      text.includes('kush mango') ||
      text.includes('mango')
    ) {
      return true;
    }

    if (typeof document !== 'undefined') {
      const activeFlavour = document.querySelector('.flavour-pill.is-active, .active-flavour-name');
      if (activeFlavour && activeFlavour.textContent.toLowerCase().includes('mango')) {
        return true;
      }
      const activeCompRow = document.querySelector('.uq-row--current');
      if (activeCompRow && activeCompRow.textContent.toLowerCase().includes('mango')) {
        return true;
      }
      const preorderNotice = document.querySelector('.cz-preorder-card, .cz-preorder-notice');
      if (preorderNotice && preorderNotice.textContent.toLowerCase().includes('mango')) {
        return true;
      }
    }

    return false;
  }

  function getLimitFromTypeOrTags(type, tagsStr, extraContext) {
    const pType = (type || '').toLowerCase();
    const tags = (tagsStr || '').toLowerCase().split(',').map(t => t.trim());

    // 1. FIRST PRIORITY: MANGO GUMMIES IS ALWAYS 10
    const combinedStr = [
      pType,
      tagsStr || '',
      typeof extraContext === 'object' ? JSON.stringify(extraContext) : (extraContext || '')
    ].join(' ').toLowerCase();

    if (isMangoGummiesItem(extraContext) || isMangoGummiesItem(combinedStr)) {
      return 10;
    }

    // 2. Check tags for explicit limit:N pattern for other products
    for (let tag of tags) {
      if (tag.startsWith('limit:')) {
        const num = parseInt(tag.replace('limit:', ''), 10);
        if (!isNaN(num) && num > 0) return num;
      }
    }

    // 3. Check Product Type or tags for Oral Drops (Maximum 3)
    if (pType.includes('oral drops') || pType.includes('drops') || tags.includes('drops') || tags.includes('oral drops')) {
      return 3;
    }

    // 4. Check Product Type or tags for other Gummies (Maximum 6)
    if (pType.includes('gummies') || tags.includes('gummies')) {
      return 6;
    }

    return null;
  }

  function showLimitToast(message) {
    let container = document.getElementById('cart-limit-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'cart-limit-toast-container';
      container.style.cssText = `
        position: fixed;
        bottom: 24px;
        right: 24px;
        z-index: 999999;
        display: flex;
        flex-direction: column;
        gap: 10px;
        pointer-events: none;
      `;
      document.body.appendChild(container);
    }

    const toast = document.createElement('div');
    toast.className = 'cart-limit-toast';
    toast.style.cssText = `
      background: #1f2937;
      color: #ffffff;
      padding: 14px 20px;
      border-radius: 10px;
      box-shadow: 0 10px 25px rgba(0,0,0,0.25);
      font-family: inherit;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 12px;
      border-left: 4px solid #f59e0b;
      opacity: 0;
      transform: translateY(20px);
      transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
      pointer-events: auto;
      max-width: 380px;
    `;

    toast.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
        <line x1="12" y1="9" x2="12" y2="13"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
      <span>${message}</span>
    `;

    container.appendChild(toast);

    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(20px)';
      setTimeout(() => toast.remove(), 300);
    }, 4000);
  }

  async function getCartData() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      return await res.json();
    } catch (e) {
      console.error('Error fetching cart:', e);
      return null;
    }
  }

  function resolveInputMaxLimit(input) {
    if (!input) return null;
    const wrapper = input.closest('quantity-selector, .quantity, quantity-input');
    const form = input.closest('form, .product-form') || document.querySelector('.product-form');
    const cartItem = input.closest('.cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]');

    const context = [
      form?.dataset?.productHandle || '',
      form?.dataset?.productTitle || '',
      form?.dataset?.productType || '',
      input.getAttribute('aria-label') || '',
      cartItem?.textContent || '',
      window.location.pathname,
      document.title
    ].join(' ');

    if (isMangoGummiesItem(context)) {
      input.setAttribute('max', '10');
      input.setAttribute('data-max', '10');
      input.setAttribute('data-max-limit', '10');
      return 10;
    }

    const maxAttr = input.getAttribute('max') || input.dataset.maxLimit || input.dataset.max;
    if (maxAttr) {
      const num = parseInt(maxAttr, 10);
      if (!isNaN(num) && num > 0) return num;
    }

    return null;
  }

  // Intercept Plus button click on quantity inputs
  document.addEventListener('click', function (e) {
    const plusBtn = e.target.closest('button[name="plus"], .quantity__button[name="plus"]');
    if (!plusBtn) return;

    const wrapper = plusBtn.closest('quantity-selector, .quantity, quantity-input');
    if (!wrapper) return;

    const input = wrapper.querySelector('input[type="number"], .quantity__input');
    if (!input) return;

    const maxLimit = resolveInputMaxLimit(input);
    if (!maxLimit) return;

    const currentVal = parseInt(input.value || '1', 10);

    if (currentVal >= maxLimit) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      showLimitToast(`Limit reached: Maximum ${maxLimit} units allowed for this item.`);
    }
  }, true);

  // Intercept input value change on quantity inputs
  document.addEventListener('change', function (e) {
    const input = e.target.closest('input.quantity__input, quantity-input input');
    if (!input) return;

    const maxLimit = resolveInputMaxLimit(input);
    if (!maxLimit) return;

    const currentVal = parseInt(input.value || '1', 10);

    if (currentVal > maxLimit) {
      input.value = maxLimit;
      showLimitToast(`Limit reached: Maximum ${maxLimit} units allowed for this item.`);
    }
  }, true);

  function enforceInputLimits() {
    const inputs = document.querySelectorAll('quantity-input input, .quantity input, input.quantity__input');
    inputs.forEach(input => {
      const max = resolveInputMaxLimit(input);
      const wrapper = input.closest('quantity-input, quantity-selector');
      if (wrapper && max) {
        const plusBtn = wrapper.querySelector('button[name="plus"]');
        const val = parseInt(input.value || '1', 10);
        if (plusBtn && val < max) {
          plusBtn.removeAttribute('disabled');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceInputLimits);
  } else {
    enforceInputLimits();
  }

  // Observe dynamically loaded elements (e.g., variant changes, cart drawer open)
  try {
    const observer = new MutationObserver(() => {
      enforceInputLimits();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (err) {}

  // Global Add to Cart Interceptor (Forms & Ajax)
  async function validateAddToCart(formOrData) {
    let productId = null;
    let variantId = null;
    let requestedQty = 1;
    let productType = '';
    let productTags = '';
    let productTitle = '';
    let productHandle = '';
    let maxLimit = null;

    if (formOrData instanceof HTMLFormElement) {
      const form = formOrData;
      const qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput) requestedQty = parseInt(qtyInput.value, 10) || 1;

      const variantInput = form.querySelector('[name="id"]');
      if (variantInput) variantId = parseInt(variantInput.value, 10);

      const parentWrapper = form.closest('.product-form') || form;
      productType = parentWrapper.dataset?.productType || form.dataset?.productType || '';
      productTags = parentWrapper.dataset?.productTags || form.dataset?.productTags || '';
      productTitle = parentWrapper.dataset?.productTitle || form.dataset?.productTitle || document.title || '';
      productHandle = parentWrapper.dataset?.productHandle || form.dataset?.productHandle || window.location.pathname || '';

      const contextStr = `${productTitle} ${productHandle} ${productTags}`;
      if (isMangoGummiesItem(contextStr)) {
        maxLimit = 10;
      } else {
        const maxData = parentWrapper.dataset?.maxLimit || parentWrapper.querySelector('[data-max-limit]')?.dataset?.maxLimit || qtyInput?.getAttribute('max');
        if (maxData) maxLimit = parseInt(maxData, 10);
        if (!maxLimit) {
          maxLimit = getLimitFromTypeOrTags(productType, productTags, contextStr);
        }
      }
    } else if (typeof formOrData === 'object' && formOrData !== null) {
      variantId = formOrData.id || (formOrData.items && formOrData.items[0]?.id);
      requestedQty = parseInt(formOrData.quantity || (formOrData.items && formOrData.items[0]?.quantity) || 1, 10);
    }

    const cart = await getCartData();
    if (!cart) return true;

    let existingQty = 0;
    let targetType = productType;
    let targetTags = productTags;

    if (cart.items && cart.items.length > 0) {
      for (let item of cart.items) {
        const itemLimit = getLimitFromTypeOrTags(item.product_type, (item.options_with_values || []).map(o => o.value).join(','), item);
        
        if (variantId && item.variant_id === variantId) {
          existingQty += item.quantity;
          if (!maxLimit) {
            maxLimit = itemLimit || getLimitFromTypeOrTags(item.product_type, '', item);
          }
        }
      }
    }

    if (!maxLimit && (targetType || targetTags)) {
      maxLimit = getLimitFromTypeOrTags(targetType, targetTags);
    }

    if (maxLimit && maxLimit > 0) {
      if (existingQty + requestedQty > maxLimit) {
        const remaining = Math.max(0, maxLimit - existingQty);
        if (remaining === 0) {
          showLimitToast(`You already have maximum limit of ${maxLimit} units of this item in your cart.`);
        } else {
          showLimitToast(`Limit reached: You can only add ${remaining} more unit(s) of this item (Max limit: ${maxLimit}).`);
        }
        return false;
      }
    }

    return true;
  }

  // Intercept native form submit on cart forms
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const isValid = await validateAddToCart(form);
    if (!isValid) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  // Expose helper globally
  window.CartLimitHandler = {
    getLimitFromTypeOrTags,
    showLimitToast,
    validateAddToCart,
    isMangoGummiesItem,
    enforceInputLimits
  };
})();
